import { differenceInDays } from 'date-fns';
import { FunctionComponent } from 'react';

import { Tag } from '../../../../atoms/Tag';
import { TAG_VARIANT } from '../../../../atoms/Tag/Tag.types';
import { SafeFormattedMessageWithoutSpread } from '../../../../formatters';
import messages from '../messages';

interface FiltersDateTagProps {
  startDate?: Date;
  endDate?: Date;
  dataTestId?: string;
}

const FiltersDateTag: FunctionComponent<FiltersDateTagProps> = ({
  startDate,
  endDate,
  dataTestId,
}) => {
  return (
    <Tag variant={TAG_VARIANT.PRIMARY} withoutMargin dataTestId={dataTestId}>
      {startDate && endDate && differenceInDays(endDate, startDate)}
      {startDate && !endDate && (
        <span>{`> ${startDate.toLocaleDateString('default', {
          day: '2-digit',
          month: '2-digit',
        })}`}</span>
      )}
      {!startDate && endDate && (
        <span>{`< ${endDate.toLocaleDateString('default', {
          day: '2-digit',
          month: '2-digit',
        })}`}</span>
      )}
      {!startDate && !endDate && (
        <SafeFormattedMessageWithoutSpread message={messages.allSelected} />
      )}
    </Tag>
  );
};

FiltersDateTag.displayName = 'FiltersDateTag';
export default FiltersDateTag;
